import React, { useState, useEffect } from "react";
import InputMask from "react-input-mask";
import "./Kirish.css";
import { toast } from "react-toastify";
import CONFIG from "../config";

function Kirish() {
    const [login, setLogin] = useState("");
    const [parol, setParol] = useState("");

    useEffect(() => {
        const token = localStorage.getItem("loyiha_token");
        const user = localStorage.getItem("loyiha_user");
        if (token && user) {
            window.location.href = "/bosh";
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${CONFIG.API_BASE_URL}/login.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ login, parol })
            }).then(r => r.json());

            if (res.status === 'success') {
                localStorage.setItem("loyiha_user", JSON.stringify(res.user));
                localStorage.setItem("loyiha_token", res.token);
                toast.success("Xush kelibsiz!");
                window.location.href = "/bosh";
            } else {
                toast.error(res.message);
            }
        } catch (err) {
            toast.error("Tizimga kirishda xatolik yuz berdi");
        }
    };

    return (
        <div className="kirish-quti">
            <form className="kirish-forma" onSubmit={handleSubmit}>
                <h2 className="kirish-sarlavha">Tizimga Kirish</h2>
                <div className="kirish-input-group">
                    <label htmlFor="login">Log (Telefon)</label>
                    <InputMask
                        mask="(99) 999-99-99"
                        maskChar="_"
                        id="login"
                        type="text"
                        className="kirish-input"
                        value={login}
                        onChange={(e) => setLogin(e.target.value)}
                        placeholder="(99) 999-99-99"
                        required
                    />
                </div>
                <div className="kirish-input-group">
                    <label htmlFor="parol">Parol</label>
                    <input
                        id="parol"
                        type="password"
                        className="kirish-input"
                        value={parol}
                        onChange={(e) => setParol(e.target.value)}
                        placeholder="Parolni kiriting"
                        required
                    />
                </div>
                <button type="submit" className="kirish-tugma">
                    Kirish
                </button>
            </form>
        </div>
    );
}

export default Kirish;
